document.addEventListener('DOMContentLoaded', () => {
    const canvas = document.getElementById('sphere-canvas');
    if (!canvas) { /* ... error handling ... */ return; }
    const ctx = canvas.getContext('2d');
    if (!ctx) { /* ... error handling ... */ return; }

    // --- Canvas and Scene Setup ---
    const canvasWidth = 800;
    const canvasHeight = 800;
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;
    const perspective = canvasWidth * 0.8;
    const projectionCenterX = canvasWidth / 2;
    const projectionCenterY = canvasHeight / 2;


    // --- Configuration (User Prefs) ---
    let numDots = 150;           // User Pref: Dot Count
    const sphereRadius = 250;
    const dotSize = 100;            // User Pref: Thicker Dots
    // const rotationSpeed = 0.0005; 
    const rotationSpeed = 0.0006;    // User Pref: Slower Rotation
    const dotColorHex = '#000000';  // User Pref: Dot Base Color
    // --- Glow properties removed ---
    // const glowBlur = 8;
    // const glowColor = dotColorHex;


    // --- Fixed Tilt (Viewer Angle) ---
    const tiltAngleX = Math.PI / 4;
    const cosTiltX = Math.cos(tiltAngleX);
    const sinTiltX = Math.sin(tiltAngleX);

    // --- Fluctuation Settings ---
    // (Keeping pointy settings)
    const newMaxAffectedAngle = Math.PI / 10;
    const newCosMaxAffectedAngle = Math.cos(newMaxAffectedAngle);
    const newOneMinusCosMaxAngle = 1 - newCosMaxAffectedAngle;
    const fluctuationSettings = {
        maxConcurrent: 5, maxStrength: 45, growDuration: 600, shrinkDuration: 3000,
        maxAffectedAngle: newMaxAffectedAngle, cosMaxAffectedAngle: newCosMaxAffectedAngle,
        oneMinusCosMaxAngle: newOneMinusCosMaxAngle < 1e-9 ? 1e-9 : newOneMinusCosMaxAngle,
        minSpawnDelay: 800, randomSpawnDelay: 1200
    };

    // --- Helper Function: Convert Hex to RGB ---
    function hexToRgb(hex) {
        let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? { r: parseInt(result[1], 16), g: parseInt(result[2], 16), b: parseInt(result[3], 16) } : null;
    }
    const dotColorRGB = hexToRgb(dotColorHex);
    if (!dotColorRGB) { console.error("Invalid dotColorHex"); dotColorRGB = { r: 255, g: 255, b: 255 }; }

    let activeFluctuations = [];
    let nextSpawnTimeout = null;
    const dots = [];

    function getCartesianCoords(radius, theta, phi) {
        const sinPhi = Math.sin(phi);
        return { x: radius * sinPhi * Math.cos(theta), y: radius * Math.cos(phi), z: radius * sinPhi * Math.sin(theta) };
    }

    function trySpawnFluctuation(currentTime) {
        // (Function remains the same)
         nextSpawnTimeout = null; if (activeFluctuations.length < fluctuationSettings.maxConcurrent) { const epicenterPhi = Math.acos(1 - 2 * Math.random()); const epicenterTheta = Math.random() * 2 * Math.PI; const epicenterCartesian = getCartesianCoords(sphereRadius, epicenterTheta, epicenterPhi); activeFluctuations.push({ epicenterCartesian: epicenterCartesian, startTime: currentTime, maxStrength: fluctuationSettings.maxStrength, growDuration: fluctuationSettings.growDuration, shrinkDuration: fluctuationSettings.shrinkDuration, cosMaxAffectedAngle: fluctuationSettings.cosMaxAffectedAngle, oneMinusCosMaxAngle: fluctuationSettings.oneMinusCosMaxAngle }); } const nextDelay = fluctuationSettings.minSpawnDelay + Math.random() * fluctuationSettings.randomSpawnDelay; nextSpawnTimeout = setTimeout(() => trySpawnFluctuation(performance.now()), nextDelay);
    }

    function init() {
        // (Initialization code remains the same)
        console.log(`Initializing sphere with ${numDots} dots (size ${dotSize}px, color ${dotColorHex}) using Canvas 2D.`);
        const goldenAngle = Math.PI * (3 - Math.sqrt(5)); const radiusSq = sphereRadius * sphereRadius;
        for (let i = 0; i < numDots; i++) {
            const y = 1 - (i / (numDots - 1)) * 2; const radiusAtY = Math.sqrt(1 - y * y); const theta = goldenAngle * i; const phi = Math.acos(y);
            const baseCoords = getCartesianCoords(sphereRadius, theta, phi);
            dots.push({ baseX: baseCoords.x, baseY: baseCoords.y, baseZ: baseCoords.z, baseVec: { x: baseCoords.x, y: baseCoords.y, z: baseCoords.z }, phi: phi, theta: theta, radiusSquared: radiusSq, finalX_3D: baseCoords.x, finalY_3D: baseCoords.y, finalZ_3D: baseCoords.z, screenX: 0, screenY: 0, scale: 1, opacity: 1 });
        }
        trySpawnFluctuation(performance.now());
        requestAnimationFrame(animate);
    }

    let currentRotationY = 0;

    function animate(time) {
        currentRotationY += rotationSpeed; // Using the user's slower speed
        const cosY = Math.cos(currentRotationY);
        const sinY = Math.sin(currentRotationY);

        // 1. --- Cleanup Finished Fluctuations ---
        // (Code remains the same)
        activeFluctuations = activeFluctuations.filter(fl => (time - fl.startTime) < (fl.growDuration + fl.shrinkDuration));

        // 2. --- Update Dot States ---
        dots.forEach(dot => {
            // (Calculation logic remains the same)
             let totalDisplacement = 0; activeFluctuations.forEach(fl => { const elapsed = time - fl.startTime; let currentStrength = 0; if (elapsed < fl.growDuration) { let t = elapsed / fl.growDuration; currentStrength = fl.maxStrength * t * (2 - t); } else { let t = Math.min(1, (elapsed - fl.growDuration) / fl.shrinkDuration); currentStrength = fl.maxStrength * (1 - t * t); } currentStrength = Math.max(0, currentStrength); if (currentStrength > 0.01 && dot.radiusSquared > 0) { const dotProduct = dot.baseVec.x * fl.epicenterCartesian.x + dot.baseVec.y * fl.epicenterCartesian.y + dot.baseVec.z * fl.epicenterCartesian.z; const cosAngle = Math.max(-1, Math.min(1, dotProduct / dot.radiusSquared)); if (cosAngle > fl.cosMaxAffectedAngle) { const t = (cosAngle - fl.cosMaxAffectedAngle) / fl.oneMinusCosMaxAngle; const proximityT = Math.max(0, Math.min(1, t)); const proximityFactor = Math.pow(proximityT, 4); totalDisplacement += currentStrength * proximityFactor; } } }); const currentRadius = sphereRadius + totalDisplacement; let workingX = dot.baseX; let workingY = dot.baseY; let workingZ = dot.baseZ; if (sphereRadius > 0 && Math.abs(totalDisplacement) > 0.01) { const radiusRatio = currentRadius / sphereRadius; workingX *= radiusRatio; workingY *= radiusRatio; workingZ *= radiusRatio; } const rotatedX_Y = workingX * cosY + workingZ * sinY; const rotatedZ_Y = -workingX * sinY + workingZ * cosY; const rotatedY_Y = workingY; dot.finalX_3D = rotatedX_Y; dot.finalY_3D = rotatedY_Y * cosTiltX - rotatedZ_Y * sinTiltX; dot.finalZ_3D = rotatedY_Y * sinTiltX + rotatedZ_Y * cosTiltX; dot.scale = Math.max(0.15, (dot.finalZ_3D + sphereRadius * 1.5) / (sphereRadius * 3)); dot.opacity = Math.max(0.2, dot.scale); const perspectiveFactor = perspective / (perspective + dot.finalZ_3D); dot.screenX = projectionCenterX + dot.finalX_3D * perspectiveFactor; dot.screenY = projectionCenterY + dot.finalY_3D * perspectiveFactor;
        });

        // 3. --- Sort Dots by Z-depth ---
        // (Code remains the same)
        dots.sort((a, b) => a.finalZ_3D - b.finalZ_3D);

        // 4. --- Render Dots on Canvas ---
        ctx.clearRect(0, 0, canvasWidth, canvasHeight);

        // *** Glow Properties REMOVED ***
        // ctx.shadowBlur = glowBlur;
        // ctx.shadowColor = glowColor;
        // ctx.shadowOffsetX = 0;
        // ctx.shadowOffsetY = 0;

        dots.forEach(dot => {
            const clampedOpacity = Math.max(0, Math.min(1, dot.opacity));
            // Use pre-calculated RGB color and calculated opacity
            ctx.fillStyle = `rgba(${dotColorRGB.r}, ${dotColorRGB.g}, ${dotColorRGB.b}, ${clampedOpacity})`;

            // Use the user's thicker dotSize here
            const drawRadius = Math.max(0.5, (dotSize / 2) * dot.scale);

            ctx.beginPath();
            ctx.arc(dot.screenX, dot.screenY, drawRadius, 0, Math.PI * 2);
            ctx.fill();
        });

        // *** Resetting shadow properties is no longer needed ***
        // ctx.shadowBlur = 0;


        // 5. --- Request Next Frame ---
        requestAnimationFrame(animate);
    }

    // Visibility change handling
    // (Code remains the same)
     document.addEventListener("visibilitychange", () => { if (document.hidden) { if (nextSpawnTimeout) { clearTimeout(nextSpawnTimeout); nextSpawnTimeout = null; } } else { if (!nextSpawnTimeout && dots.length > 0) { setTimeout(() => trySpawnFluctuation(performance.now()), 500); } } });

    // Start initialization
    init();
});